

export const AssessmentLabels = ["Flow Control", "Data representation", "Abstraction", "User interactivity", "Synchronization", "Parallelism", "Logic"]
